import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const portfolioImages = [
  { src: '/images/OakleyPortfolio.png', alt: 'Oakley808 Website' },
  { src: '/images/StellenAvosPortfolio.png', alt: 'Stellen Avos Website' },
  { src: '/images/SavoyPortfolio.png', alt: 'Savoy Website' },
  { src: '/images/TeamFlippyPortfolio.png', alt: 'Team Flippy Website' },
  { src: '/images/PJDPortfolio.png', alt: 'PJD Website' },
  { src: '/images/DDPortfolio.png', alt: 'DD Website' },
  { src: '/images/DJPortfolioWeb.png', alt: 'DJ Website' },
  { src: '/images/RooibosPowerhousePortfolio.png', alt: 'Rooibos Powerhouse Website' },
  { src: '/images/ShanShimmersPortfolio.png', alt: 'Shan Shimmers Website' },
  { src: '/images/SwakopmundBackpackersPortfolio.png', alt: 'Swakopmund Backpackers Website' }
];

const PortfolioSlider: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  // Preload images
  useEffect(() => {
    portfolioImages.forEach(image => {
      const img = new Image();
      img.src = image.src;
    });
  }, []);

  const nextSlide = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentIndex((prevIndex) => 
      prevIndex === portfolioImages.length - 1 ? 0 : prevIndex + 1
    );
    setTimeout(() => setIsTransitioning(false), 200);
  };

  const prevSlide = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? portfolioImages.length - 1 : prevIndex - 1
    );
    setTimeout(() => setIsTransitioning(false), 200);
  };

  // Preload next and previous images
  const nextIndex = (currentIndex + 1) % portfolioImages.length;
  const prevIndex = currentIndex === 0 ? portfolioImages.length - 1 : currentIndex - 1;

  return (
    <div className="relative w-full h-[600px] rounded-lg shadow-lg overflow-hidden bg-gray-100">
      {/* Current Image */}
      <img
        src={portfolioImages[currentIndex].src}
        alt={portfolioImages[currentIndex].alt}
        className={`w-full h-full object-contain transition-opacity duration-200 ${isTransitioning ? 'opacity-50' : 'opacity-100'}`}
        loading="eager"
      />
      
      {/* Preload next and previous images */}
      <img
        src={portfolioImages[nextIndex].src}
        alt={portfolioImages[nextIndex].alt}
        className="hidden"
        loading="lazy"
      />
      <img
        src={portfolioImages[prevIndex].src}
        alt={portfolioImages[prevIndex].alt}
        className="hidden"
        loading="lazy"
      />
      
      <button
        onClick={prevSlide}
        disabled={isTransitioning}
        className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white p-2 rounded-full transition-colors duration-200 disabled:opacity-50"
        aria-label="Previous image"
      >
        <ChevronLeft className="w-6 h-6 text-[#224c5c]" />
      </button>
      
      <button
        onClick={nextSlide}
        disabled={isTransitioning}
        className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white p-2 rounded-full transition-colors duration-200 disabled:opacity-50"
        aria-label="Next image"
      >
        <ChevronRight className="w-6 h-6 text-[#224c5c]" />
      </button>
      
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex space-x-2">
        {portfolioImages.map((_, index) => (
          <button
            key={index}
            onClick={() => {
              if (!isTransitioning) {
                setIsTransitioning(true);
                setCurrentIndex(index);
                setTimeout(() => setIsTransitioning(false), 200);
              }
            }}
            disabled={isTransitioning}
            className={`w-2 h-2 rounded-full transition-colors duration-200 ${
              index === currentIndex ? 'bg-white' : 'bg-white/50'
            } disabled:opacity-50`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default PortfolioSlider;